import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Link } from "react-router-dom";
const faqs = [{
  question: "What is AurØra?",
  answer: "AurØra is a platform that provides structured, on-chain access to income generated by professionally managed property in the United Kingdom. Access is delivered through income rights, not property ownership."
}, {
  question: "What do AurØra tokens represent?",
  answer: "Tokens represent contractual rights to income generated by the underlying property portfolio. They do not represent ownership of property, equity, or governance rights."
}, {
  question: "Do I own property through AurØra?",
  answer: "No. Participation does not involve owning property or having control over assets. AurØra manages acquisition, financing, and operations."
}, {
  question: "How is income generated and tracked?",
  answer: "Income is generated from rental operations across the portfolio and tracked through on-chain infrastructure, providing transparent reporting and allocation."
}, {
  question: "Is leverage used?",
  answer: "Leverage may be applied at the asset level where appropriate to improve capital efficiency. Participants are not personally leveraged."
}, {
  question: "Who manages the properties?",
  answer: "All properties are professionally managed by experienced operators under AurØra's oversight and discipline framework."
}, {
  question: "Who can access AurØra?",
  answer: "AurØra is designed for a global audience, subject to applicable laws and platform requirements. Access may vary by jurisdiction."
}, {
  question: "What risks are involved?",
  answer: "risk-disclosure-link"
}];

const FAQ = () => {
  const leftColumn = faqs.slice(0, 4);
  const rightColumn = faqs.slice(4);
  
  return (
    <section id="faq" aria-labelledby="faq-heading" className="lg:py-32 relative py-[25px] overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-full">
        <div className="text-center mb-12">
          <h2 id="faq-heading" className="text-lg md:text-xl font-normal mb-3 text-foreground">
            Your Questions, Answered
          </h2>
          
          <p className="text-foreground/70 text-sm md:text-base max-w-xl mx-auto">
            Clear answers on structure, access, and how AurØra operates.
          </p>
        </div>

        <div className="max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-x-16 gap-y-0">
          <Accordion type="single" collapsible className="space-y-0">
            {leftColumn.map((faq, index) => (
              <AccordionItem key={index} value={`left-${index}`} className="border-b border-border/30 bg-transparent">
                <AccordionTrigger className="text-left text-base font-normal text-foreground hover:text-foreground hover:no-underline py-4">
                  {faq.question}
                </AccordionTrigger>
              <AccordionContent className="text-foreground/70 text-sm pb-4 leading-relaxed">
                  {faq.answer === "risk-disclosure-link" ? (
                    <>Participation involves risk. Income is variable, property performance can change, and outcomes are not guaranteed. Users should review the <Link to="/risk-disclosure" className="text-foreground underline hover:text-foreground/80 transition-colors">Risk Disclosure</Link> before participating.</>
                  ) : faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          <Accordion type="single" collapsible className="space-y-0">
            {rightColumn.map((faq, index) => (
              <AccordionItem key={index} value={`right-${index}`} className="border-b border-border/30 bg-transparent">
                <AccordionTrigger className="text-left text-base font-normal text-foreground hover:text-foreground hover:no-underline py-4">
                  {faq.question}
                </AccordionTrigger>
              <AccordionContent className="text-foreground/70 text-sm pb-4 leading-relaxed">
                  {faq.answer === "risk-disclosure-link" ? (
                    <>Participation involves risk. Income is variable, property performance can change, and outcomes are not guaranteed. Users should review the <Link to="/risk-disclosure" className="text-foreground underline hover:text-foreground/80 transition-colors">Risk Disclosure</Link> before participating.</>
                  ) : faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};
export default FAQ;